<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> RELATÓRIO DE PRODUTOS </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col>
              <v-autocomplete
                :items="providers"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="provider"
                label="Fornecedor"
                hide-details
                clearable
                dense
                outlined
                multiple
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip small v-if="index === 0">
                    <span
                      >{{ item.code }} -
                      {{ item.name.substring(0, 5) }}...</span
                    >
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    [+{{ provider.length - 1 }}]
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-select
                :items="collections"
                item-text="name"
                item-value="id"
                v-model="collection"
                label="Coleção"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="productTypes"
                item-text="name"
                item-value="id"
                v-model="productType"
                label="Tipo de Produto"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="categories"
                item-text="name"
                item-value="id"
                v-model="category"
                label="Categoria"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="subcategories"
                item-text="name"
                item-value="id"
                v-model="subcategory"
                label="Subcategoria"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                v-model="reference"
                label="Referência"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                :items="disabledOptions"
                label="Desabilitado?"
                dense
                hide-details
                outlined
                v-model="disabled"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="launchOptions"
                label="Somente Lançamento?"
                dense
                hide-details
                outlined
                v-model="launch"
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field-money
                v-model="price_start"
                label="Preço de"
                v-bind:properties="{
                  prefix: 'R$',
                  readonly: false,
                  dense: true,
                  outlined: true,
                  clearable: false,
                  hideDetails: true,
                  placeholder: ' ',
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: null,
                }"
              />
            </v-col>
            <v-col>
              <v-text-field-money
                v-model="price_end"
                label="Até"
                v-bind:properties="{
                  prefix: 'R$',
                  readonly: false,
                  dense: true,
                  outlined: true,
                  clearable: false,
                  hideDetails: true,
                  placeholder: ' ',
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: null,
                }"
              />
            </v-col>
            <v-col>
              <v-select
                :items="columnsPDF"
                label="Colunas PDF"
                dense
                hide-details
                outlined
                v-model="columns"
                multiple
                small-chips
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip small v-if="index === 0">
                    <span>{{ item.text }} &nbsp;</span>
                  </v-chip>

                  <span
                    v-if="columns.length && index === 1"
                    class="text-caption"
                  >
                    [ +{{ columns.length - 1 }} ]
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-2"
                @click="getProducts()"
              >
                Executar Consulta
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                :disabled="products.length == 0"
                @click="exportReport('excel')"
                color="grey darken-4"
                outlined
                small
                class="mt-3 float-right"
              >
                <v-icon color="green" left> mdi-file-excel-box </v-icon>
                Excel
              </v-btn>
              <v-btn
                :disabled="products.length == 0"
                @click="exportReport('pdf')"
                color="grey darken-4"
                outlined
                small
                class="mt-3 mr-1 float-right"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="380">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left fs-12 text-no-wrap">
                                Referência
                              </th>
                              <th class="text-left fs-12 text-no-wrap">Nome</th>
                              <th class="text-left fs-12 text-no-wrap">
                                Fornecedor
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Categoria
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Subcategoria
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Cadastro
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Atualização
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Preço Rede
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Preço Multimarcas
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="product in products" :key="product.id">
                              <td>
                                {{ product.codeFull }}
                              </td>
                              <td>
                                {{ product.name }}
                              </td>
                              <td class="text-no-wrap">
                                {{ product.provider_code }} -
                                {{ product.provider_name }}
                              </td>
                              <td v-if="product.category_name">
                                {{ product.category_name }}
                              </td>
                              <td v-else></td>
                              <td v-if="product.subcategory_name">
                                {{ product.subcategory_name }}
                              </td>
                              <td v-else></td>
                              <td>
                                {{ product.created_at | datetimeFormatBr }}
                              </td>
                              <td>
                                {{ product.updated_at | datetimeFormatBr }}
                              </td>
                              <td class="text-right">
                                {{ product.price_cif | currencyEuaToBr }}
                              </td>
                              <td class="text-right">
                                {{ product.price_mult | currencyEuaToBr }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="products.length > 0">
                            <tr>
                              <th colspan="40">
                                Total de Produtos:
                                {{ products.length }}
                              </th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";
import * as CategoryAPI from "@/api/requests/CategoryRequest";
import * as CollectionAPI from "@/api/requests/CollectionRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as SubcategoryAPI from "@/api/requests/SubcategoryRequest";

export default {
  components: { Alert },
  data: () => ({
    loading: false,
    showAlert: false,
    lazy: false,
    valid: true,
    typeAlert: "error",
    messageAlert: "",
    collections: [],
    providers: [],
    productTypes: [],
    categories: [],
    subcategories: [],
    reference: "",
    provider: [],
    collection: "",
    productType: "",
    category: "",
    subcategory: "",
    price_end: "",
    price_start: 0,
    disabledOptions: [
      { value: 0, text: "Não" },
      { value: 1, text: "Sim" },
    ],
    launchOptions: [
      { value: 0, text: "Não" },
      { value: 1, text: "Sim" },
    ],
    imagesOptions: [
      { value: 0, text: "Não" },
      { value: 1, text: "Sim" },
    ],
    image: 0,
    disabled: 0,
    launch: 0,
    products: [],
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
    columnsPDF: [
      { value: "reference", text: "Referência" },
      { value: "image", text: "Foto Produto" },
      { value: "name", text: "Nome Produto" },
      { value: "provider", text: "Fornecedor" },
      { value: "category", text: "Categoria" },
      { value: "subcategory", text: "Subcategoria" },
      { value: "created_at", text: "Data Cadastro" },
      { value: "updated_at", text: "Data Atualização" },
      { value: "price_cif", text: "Preço Rede" },
      { value: "price_mult", text: "Preço Multimarcas" },
    ],
    columns: [],
  }),
  computed: {},
  created() {
    this.columns = this.columnsPDF
      .filter((item) => item.value !== "image")
      .map((item) => item.value);
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getProviders();
      this.getCollections();
      this.getCategories();
      this.getSubcategories();
      this.getProductsTypes();
    },
    validate() {},
    async getProviders() {
      this.loadingProvider = true;
      try {
        let res = await CompanyAPI.getAll("?type=for");
        this.providers = res.sort((a, b) => (a.code < b.code ? -1 : 1));
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingProvider = false;
      }
    },
    async getCollections() {
      // this.loadingCollections = true;
      this.collections = [];
      try {
        let data = await CollectionAPI.getAll();
        this.collections = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.collections = [];
        console.log(error);
      } finally {
        // this.loadingCollections = false;
      }
    },
    async getCategories() {
      this.loading = true;
      this.categories = [];
      try {
        let data = await CategoryAPI.getAll();
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getSubcategories() {
      // this.loadingSubcategories = true;
      this.subcategories = [];
      try {
        let data = await SubcategoryAPI.getAll();
        this.subcategories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.subcategories = [];
        console.log(error);
      } finally {
        // this.loadingSubcategories = false;
        // this.loading = false;
      }
    },
    async getProductsTypes() {
      // this.loadingProductType = true;
      try {
        let response = await fetch(`${URL}product-types`);
        let data = await response.json();
        this.productTypes = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.productTypes = {};
      } finally {
        // this.loadingProductType = false;
      }
    },
    async getProducts() {
      this.showAlert = false;
      this.loading = true;
      this.products = [];
      let data = {
        provider_id: this.provider,
        collection_id: this.collection,
        category_id: this.category,
        subcategory_id: this.subcategory,
        product_type_id: this.productType,
        reference: this.reference,
        disabled: this.disabled,
        launch: this.launch,
        showImage: this.columns.find((item) => item === "image") !== undefined,
        price: [this.price_start, this.price_end],
      };
      try {
        let response = await fetch(`${URL}report/products`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        });
        let res = await response.json();
        console.log(res);
        this.products = res
          .map((item) => ({
            ...item,
            codeFull: `${item.provider_code}${item.reference}`,
          }))
          .sort((a, b) => (a.codeFull > b.codeFull ? 1 : -1));
      } catch (error) {
        this.messageAlert =
          "Não foi possível carregar os Produtos, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    async exportReport(type) {
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.products = this.products;
      data.showImage = this.image;
      data.showColumns = this.columns;
      this.loading = true;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}report/export-product/${type}`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.download.name = response.nome;
        this.download.link = `${URL}report/download-product/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.v-data-table {
  overflow-x: auto;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
